import { ReducerAction } from 'store/modules/types';

import { Types, RequestEnviaSMSPositus } from './types';

export function enviaSMSPositusRequest(
	data: RequestEnviaSMSPositus,
): ReducerAction {
	return {
		type: Types.ENVIAR_SMS_POSITUS_REQUEST,
		payload: data,
	};
}
export function enviaSMSPositusSuccess(payload: object): ReducerAction {
	return {
		type: Types.ENVIAR_SMS_POSITUS_SUCCESS,
		payload,
	};
}
export function enviaSMSPositusFailure(payload: boolean): ReducerAction {
	return {
		type: Types.ENVIAR_SMS_POSITUS_FAILURE,
		payload,
	};
}
export function enviaSMSPositusClear(): ReducerAction {
	return {
		type: Types.ENVIAR_SMS_POSITUS_CLEAR,
		payload: null,
	};
}
